import React, { ReactNode, createContext, useContext } from "react";

import type { MeetingContextType } from "../types";

const MeetingContext = createContext<MeetingContextType | undefined>(undefined);

type MeetingProviderProps = {
	children: ReactNode;
	value: MeetingContextType;
};

/**
 * Provider component for meeting context.
 * Provides meeting data and interaction handlers to all child components.
 */
export const MeetingProvider = ({ children, value }: MeetingProviderProps): React.ReactElement => {
	return <MeetingContext.Provider value={value}>{children}</MeetingContext.Provider>;
};

/**
 * Hook to access meeting context.
 * Must be used within a MeetingProvider.
 */
export const useMeetingContext = (): MeetingContextType => {
	const context = useContext(MeetingContext);
	if (context === undefined) {
		throw new Error("useMeetingContext must be used within a MeetingProvider");
	}
	return context;
};
